/**
 * @generated SignedSource<<8420705df6bcb29184d2551f0e6e1e1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UnifiedProfileFragment$data = {
  readonly aaid: string | null;
  readonly accountInternalId: string | null;
  readonly bio: string | null;
  readonly company: string | null;
  readonly id: string;
  readonly internalId: string | null;
  readonly isLinkedView: boolean | null;
  readonly isPersonalView: boolean | null;
  readonly isPrivate: boolean;
  readonly isProfileBanned: boolean | null;
  readonly isProfileOwnerConsented: boolean | null;
  readonly linkedinUrl: string | null;
  readonly location: string | null;
  readonly products: string | null;
  readonly role: string | null;
  readonly username: string | null;
  readonly websiteUrl: string | null;
  readonly xUrl: string | null;
  readonly youtubeUrl: string | null;
  readonly " $fragmentType": "UnifiedProfileFragment";
};
export type UnifiedProfileFragment$key = {
  readonly " $data"?: UnifiedProfileFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UnifiedProfileFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "UnifiedProfileFragment"
};

(node as any).hash = "83600c81da532c36a91267a4fb5bf6af";

export default node;
